import React from 'react';
import PropTypes from 'prop-types';
import InlineToolbarButton from '../InlineToolbarButton.js';
import LinkIcon from '../../Icons/LinkIcon.js';
import { FORMATTING_BUTTONS } from '../../consts.js';
import 'classnames';
import '../ToolbarButton.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../../Icons/DropdownArrowIcon.js';
import '../../style-inject.es-746bb8ed.js';
import 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LinkButton = (_a) => {
  var _b = _a, { icon } = _b, otherProps = __objRest(_b, ["icon"]);
  return /* @__PURE__ */ React.createElement(
    InlineToolbarButton,
    __spreadValues({
      icon: icon || LinkIcon,
      dataHook: "LinkButton",
      formattingButtonName: FORMATTING_BUTTONS.LINK
    }, otherProps)
  );
};
LinkButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  helpers: PropTypes.object,
  isMobile: PropTypes.bool,
  tooltipText: PropTypes.string,
  pluginType: PropTypes.string,
  tabIndex: PropTypes.number,
  icon: PropTypes.func
};

export { LinkButton as default };
//# sourceMappingURL=LinkButton.js.map
